import { Form, InputNumber } from 'antd';
import PropTypes from 'prop-types';
import { useEditableCellTable } from './hooks/useEditableCellTable';

const EditableCellTable = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
}) => {
    const { toggleEdit, save, editing, inputRef } = useEditableCellTable({
        dataIndex,
        record,
        handleSave,
    });

    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: true,
                        message: `${title} is required.`,
                    },
                ]}
            >
                <InputNumber
                    type='NUMBER'
                    defaultValue={0}
                    ref={inputRef}
                    onPressEnter={save}
                    onBlur={save}
                />
            </Form.Item>
        ) : (
            <div
                role='none'
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
};

EditableCellTable.propTypes = {
    title: PropTypes.string,
    editable: PropTypes.bool,
    dataIndex: PropTypes.string, 
    record: PropTypes.object,
    handleSave: PropTypes.func,
    children: PropTypes.node,
};

export default EditableCellTable;
